import React, { useCallback, useState } from 'react';
import { useStyles } from './DateTimePickerOneMenu.styles';
import { Grid, Menu, MenuItem } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { DateTimePickerOne } from '../DateTimePickerOne.component';

interface DateTimePickerOneMenuProps {
  selectedDateFrom: Date | undefined;
  selectedDateTo?: Date | undefined;
  noBorder?: boolean;
  pickerAnchor: SVGSVGElement | HTMLElement | undefined | null;
  singleMode?: boolean;
  minDate?: Date;
  maxDate?: Date;
  automaticDateTimeExitFlow?: boolean;
  isTimePicker?: boolean;
  onChange: (dateFrom?: Date, dateTo?: Date) => void;
  onClear?: () => void;
  onClose?: () => void;
}

export const DateTimePickerOneMenu: React.FC<DateTimePickerOneMenuProps> = (props) => {
  const classes = useStyles();

  const [isTimeFromError, setIsTimeFromError] = useState<boolean>(false);
  const [isTimeToError, setIsTimeToError] = useState<boolean>(false);
  const [selectedDateFrom, setSelectedDateFrom] = useState<Date | undefined>(props.selectedDateFrom ?? undefined);
  const [selectedDateTo, setSelectedDateTo] = useState<Date | undefined>(props.selectedDateTo ?? undefined);

  const handleCloseDateRangeMenu = () => {
    props.onClose && props.onClose();
  };

  const handleClear = useCallback(() => {
    props.onClose && props.onClose();
    props.onClear && props.onClear();
  }, []);

  const handleDateFromOnChange = (value?: Date) => {
    setSelectedDateFrom(value);
    if (props.singleMode) {
      props.onChange(value);
    } else if (value && selectedDateTo) {
      const startTime = value.getTime();
      const endTime = selectedDateTo.getTime();
      if (
        value.getDate() === selectedDateTo.getDate() &&
        value.getFullYear() === selectedDateTo.getFullYear() &&
        startTime > endTime
      ) {
        setIsTimeFromError(true);
        setIsTimeToError(false);
      } else {
        setIsTimeFromError(false);
        setIsTimeToError(false);
        props.onChange(value, selectedDateTo);
      }
    }
  };

  const handleDateToOnChange = (value?: Date) => {
    setSelectedDateTo(value);
    if (selectedDateFrom && value) {
      const startTime = selectedDateFrom.getTime();
      const endTime = value.getTime();
      if (
        selectedDateFrom.getDate() === value.getDate() &&
        selectedDateFrom.getFullYear() === value.getFullYear() &&
        startTime > endTime
      ) {
        setIsTimeToError(true);
        setIsTimeFromError(false);
      } else {
        setIsTimeToError(false);
        setIsTimeFromError(false);
        props.onChange(selectedDateFrom, value);
      }
    }
  };

  return (
    <Menu
      className={classes.dateTimeMenu}
      id="date-time-menu"
      anchorEl={props.pickerAnchor}
      open={Boolean(props.pickerAnchor)}
      keepMounted
      onClose={handleCloseDateRangeMenu}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <MenuItem disableRipple>
        <Grid container justifyContent="space-around">
          <div>
            <DateTimePickerOne
              onChange={(value) => handleDateFromOnChange(value)}
              onClose={props.onClose}
              selectedDateTime={props.selectedDateFrom}
              minDate={props.minDate ?? undefined}
              maxDate={props.maxDate ?? props.selectedDateTo}
              dateLabel="Data rozpoczęcia"
              timeLabel="Godz. rozpoczęcia"
              automaticDateTimeExitFlow={props.automaticDateTimeExitFlow && props.singleMode}
              singleMode={props.singleMode}
              isTimeFromError={isTimeFromError}
              isTimePicker={props.isTimePicker}
            />
          </div>
          {!props.singleMode && (
            <div>
              <DateTimePickerOne
                onChange={(value) => handleDateToOnChange(value)}
                onClose={props.onClose}
                selectedDateTime={props.selectedDateTo}
                minDate={props.minDate ?? props.selectedDateFrom}
                maxDate={props.maxDate ?? undefined}
                dateLabel="Data zakończenia"
                timeLabel="Godz. zakończenia"
                isTimeToError={isTimeToError}
                isTimePicker={props.isTimePicker}
              />
            </div>
          )}
        </Grid>
      </MenuItem>
      {props.onClear && <hr className={classes.hr} />}
      {props.onClear && (
        <MenuItem disableRipple className={classes.clearText} onClick={handleClear}>
          <CloseIcon className={classes.clearIcon} />
          Wyczyść
        </MenuItem>
      )}
    </Menu>
  );
};
